export default {
    methods: {
        formatearFecha(fecha){
            // devuelve una fecha tipo: 2020-08-06T17:24:13.000000Z en formato: 06/08/2020 19:24
            let formato = {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric',
                hour: '2-digit',
                minute: '2-digit'
            }
            let fechaFormateada = new Date(fecha).toLocaleDateString('es-ES', formato);
            return fechaFormateada;
        }
    }
}